import script from "./DoctorManagement.vue?vue&type=script&setup=true&lang=js"
export * from "./DoctorManagement.vue?vue&type=script&setup=true&lang=js"

import "./DoctorManagement.vue?vue&type=style&index=0&id=b65d39ac&lang=css"

const __exports__ = script;

export default __exports__